export function getTimezoneCode() {
    return new Date().toLocaleTimeString('en-us', { timeZoneName: 'short' }).split(/\s/)[2];
}
